import React from 'react';

import {
  GGChart,
  GGMetric,
  GGSeries,
  GGDateAxis,
  GGMetricsTooltip,
  GGNoSeriesPlaceholder,
} from '@gogame/components';

export const FinancialResultChart = ({
  chartSeries,
  loading,
  tooltipPosStrategy,
}) => {
  return (
    <GGChart
      scale={'monthly'}
      loading={loading}
      compareMode={false}
      withPaper={false}
      hiddenToolbar={true}
    >
      {chartSeries.map(({ period, rows, metrics }, index) => {
        return (
          <GGSeries
            data={rows}
            period={period}
            seriesKey={index}
            key={index}
            dateKey={'Date'}
          >
            {metrics.map((metric) => (
              <GGMetric
                key={metric.id}
                dataKey={metric.id}
                colorKey={metric.id}
                yAxisGroup={metric.yAxisGroup}
                valueType={metric.type}
                name={metric.name}
              />
            ))}
          </GGSeries>
        );
      })}
      <GGMetricsTooltip posStrategy={tooltipPosStrategy} />
      <GGDateAxis template={'d. MMM'} />
      <GGNoSeriesPlaceholder text={'No data to display chart'} />
    </GGChart>
  );
};
